/* eslint-disable object-shorthand */
import { Grid } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDDatePicker from "components/Basics/MDDatePicker";
import Languages from "flatpickr/dist/l10n/index";
import i18n from "i18n";

const InputDate = ({ label, value, onChange, disabled, error, InputProps = {}, ...rest }) => {
	const DefaultLanguage = Languages[i18n.language] || Languages.en;

	return (
		<Grid
			size="grow"
			sx={{
				flexBasis: "16.666%", // 2 / 12 columns
				minWidth: "16.666%"
			}}
		>
			<MDBox {...rest}>
				<MDDatePicker
					type="date"
					label={label}
					value={value}
					onChange={(dateObj, dateStr, instance) => {
						onChange(dateObj[0]);
					}}
					options={{
						time_24hr: true,
						dateFormat: "d M Y",
						locale: {
							...DefaultLanguage,
							firstDayOfWeek: 1
						}
					}}
					input={{
						disabled,
						label: label,
						placeholder: `${label} `,
						...InputProps,
						style: {
							width: "100%",
							...InputProps.style
						}
					}}
					{...rest}
					disabled={disabled}
					onDayCreate={(dObj, dStr, fp, dayElem) => {
						if (dayElem.dateObj.toDateString() === new Date().toDateString()) {
							dayElem.className += " today-date";
						}
					}}
				/>
			</MDBox>
		</Grid>
	);
};
export default InputDate;
